import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Checkbox, Icon } from 'loyal-react'
import yn from 'yn'
import Delay from '../../../Interval/Delay'
import { formatNumber } from '../../../Helpers'

export default class Body extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: '',
      credit: 0,
      // TODO: trazer total de pontos do participante
      points: this.props.balance.pointsValue,
      checked: false,
      pointsIsValid: true
    }

    if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_FULL_POINTS)) {
      this.state.checked = true
      this.state.credit = this.props.balance.pointsValue
      this.handlePoint()
    }
  }

  async handleCredit (el) {
    if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_FULL_POINTS)) return
    let val = el.target.value.replace(/[^\d]/g, '')
    val = val ? parseInt(val) : ''
    this.props.handleLoadingConfirmButton(true)
    this.props.handleDisabledConfirmButton(true)
    this.setState({ value: val })
    if (val) {
      if (val < 100) {
        this.setState({ pointsIsValid: false })
      } else {
        this.setState({ pointsIsValid: true })
        let interval = this.props.intervalObservable
        let timeoutValue = 1500
        let delayedCallBack = await Delay(interval, timeoutValue, val, async (val) => {
          this.props.handleInitialCredit(val)
          let miles = await this.convertPoints(val)
          this.props.handleInitialMiles(miles)
          this.setState({ credit: miles })
          if (miles > 0) {
            this.props.handleDisabledConfirmButton(false)
          }
          if (this.state.checked) {
            this.setState({ checked: false })
          }
        })
        this.props.handleIntervalObservable(delayedCallBack)
      }
    } else {
      this.props.handleInitialCredit(0)
      this.props.handleInitialMiles(0)
    }
    this.props.handleLoadingConfirmButton(false)
  }

  async handlePoint (el) {
    this.props.handleLoadingConfirmButton(true)
    if (yn(process.env.REACT_APP_HAS_LIKE_PLUS_FULL_POINTS) || el.target.checked) {
      this.props.handleInitialCredit(this.state.points)
      let money = await this.convertPoints(this.state.points)
      this.props.handleInitialMiles(money)
      this.setState({ credit: money, value: this.state.points })
      if (money > 0) {
        this.props.handleDisabledConfirmButton(false)
      }
    } else {
      this.setState({ credit: 0, value: 0 })
      this.props.handleInitialCredit(0)
      this.props.handleDisabledConfirmButton(true)
    }
    if (!yn(process.env.REACT_APP_HAS_LIKE_PLUS_FULL_POINTS)) this.setState({ checked: !this.state.checked })
    this.props.handleLoadingConfirmButton(false)
  }

  async convertPoints (points) {
    this.props.handleLoadingConfirmButton(true)
    let res = await this.props.handlePointsConversion(points, this.props.accessToken)
    this.props.handleLoadingConfirmButton(false)
    return res !== undefined && res.money >= 0 ? res.money : 0
  }

  render () {
    return (
      <div className='col-12  bg-ui-4 border-color-ui-3 border-bottom p-2'>
        <div className='col-12'>
          <p className='my-2 p-0'>
            Realize a primeira recarga para aproveitar o seu cartão em lojas
            físicas e na internet.
          </p>
        </div>
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-start align-items-center'>
          <div className='col-12 col-md-6 p-0 d-flex flex-column'>
            <Input
              id='credit'
              label='Quantos pontos deseja creditar?'
              type='text'
              childrenClassName='has-content'
              valid={this.state.pointsIsValid ? null : false}
              data-error='Mínimo de 100 pontos'
              value={this.state.value}
              onChange={e => this.handleCredit(e)}
            />
            {
              yn(process.env.REACT_APP_LIKEPLUS_DISABLE_SELECT_ALL_POINTS) &&
                (
                  this.state.points >= 100 && (
                    <Checkbox
                      id='points'
                      label={`Creditar todos os meus ${formatNumber(this.state.points)} pontos`}
                      checked={this.state.checked}
                      disabled={yn(process.env.REACT_APP_HAS_LIKE_PLUS_FULL_POINTS)}
                      onChange={e => this.handlePoint(e)}
                    />
                  )
                )
            }
          </div>
          <div className='my-2'>
            <Icon iconName='icon_equal' className='color-brand-2-like' />
          </div>
          <div className='col-md-5 col-12'>
            <p className='mb-2'>
              <strong>Valor a ser creditado no Cartão Pré-Pago Like+</strong>
            </p>
            <h3 className='color-brand-2-like'>{formatNumber(this.state.credit, true)}</h3>
          </div>
        </div>
      </div>
    )
  }
}

Body.propTypes = {
  // initialCredit: PropTypes.any,
  handleInitialCredit: PropTypes.func,
  handleInitialMiles: PropTypes.func,
  handlePointsConversion: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object,
  intervalObservable: PropTypes.any,
  handleIntervalObservable: PropTypes.func,
  handleDisabledConfirmButton: PropTypes.func,
  handleLoadingConfirmButton: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Tabs/RequestCard/Credit/Body.js